export const TEAMS_TAG_TYPE = 'Teams';
